import React from 'react';
import { Card } from '../ui/Card';
import { MOCK_SITES } from '../../utils/multiSiteData';
import { Users, AlertCircle } from 'lucide-react';
import { cn } from '../../utils/cn';
export function GuardCoverageOverview() {
  return <Card className="h-full flex flex-col" noPadding data-id="element-184">
      <div className="p-4 border-b border-gray-800" data-id="element-185">
        <h3 className="font-semibold text-white" data-id="element-186">Guard Coverage Status</h3>
      </div>
      <div className="overflow-auto" data-id="element-187">
        <table className="w-full text-sm text-left" data-id="element-188">
          <thead className="text-xs text-gray-500 bg-gray-900/50 uppercase" data-id="element-189">
            <tr data-id="element-190">
              <th className="px-4 py-3 font-medium" data-id="element-191">Site</th>
              <th className="px-4 py-3 font-medium text-center" data-id="element-192">On Duty</th>
              <th className="px-4 py-3 font-medium text-center" data-id="element-193">Expected</th>
              <th className="px-4 py-3 font-medium text-center" data-id="element-194">Coverage</th>
              <th className="px-4 py-3 font-medium text-right" data-id="element-195">Issues</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800" data-id="element-196">
            {MOCK_SITES.map(site => {
            const coverage = Math.round(site.guards.onDuty / site.guards.expected * 100);
            const isLowCoverage = coverage < 80;
            return <tr key={site.id} className="hover:bg-gray-800/30 transition-colors" data-id="element-197">
                  <td className="px-4 py-3 font-medium text-white" data-id="element-198">
                    {site.name}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-300" data-id="element-199">
                    {site.guards.onDuty}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-500" data-id="element-200">
                    {site.guards.expected}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-201">
                    <span className={cn('px-2 py-0.5 rounded text-xs font-bold', isLowCoverage ? 'bg-red-500/10 text-red-500' : 'bg-emerald-500/10 text-emerald-500')} data-id="element-202">
                      {coverage}%
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-203">
                    {site.guards.missingExit > 0 ? <span className="inline-flex items-center text-xs text-amber-500" data-id="element-204">
                        <AlertCircle className="h-3 w-3 mr-1" data-id="element-205" />
                        {site.guards.missingExit} Missing Exit
                      </span> : <span className="text-xs text-gray-600" data-id="element-206">-</span>}
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </Card>;
}